module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor-questionnaire"
    }
  }, [_c('nav', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "field control"
  }, [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "control-line"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_for']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(_vm.tokens[("item_" + (item.name))]))])
  }))])]), _c('div', {
    staticClass: "column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.word),
      expression: "word"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type === _vm.types.word),
      expression: "type === types.word"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['ph_word']
    },
    domProps: {
      "value": (_vm.word)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.word = $event.target.value
      }
    }
  })])]), _c('p'), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['ph_question']
    },
    domProps: {
      "value": (_vm.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question = $event.target.value
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined"
  }, _vm._l((_vm.answers), function(answer) {
    return _c('div', {
      staticClass: "column"
    }, [_c('p', {
      staticClass: "control has-icon"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (answer.text),
        expression: "answer.text"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": _vm.tokens['ph_answer']
      },
      domProps: {
        "value": (answer.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(answer, "text", $event.target.value)
        }
      }
    }), (answer.text) ? [(!answer.isCorrect) ? _c('span', {
      staticClass: "icon is-small is-left checkbox"
    }, [_c('i', {
      staticClass: "fa fa-check",
      on: {
        "click": function($event) {
          _vm.selectCorrect(answer)
        }
      }
    })]) : _c('span', {
      staticClass: "icon is-small is-left checkbox is-success"
    }, [_c('i', {
      staticClass: "fa fa-check-circle",
      on: {
        "click": function($event) {
          _vm.selectCorrect(answer)
        }
      }
    })])] : _vm._e()], 2)])
  })), _c('p'), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.tokens['add']))])])])]), _c('div', {
    staticClass: "panel-block questions is-paddingless"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.questions), function(question) {
    return _c('tr', {
      key: question.question
    }, [_c('td', {
      staticClass: "is-narrow"
    }, [(question.type === 'word') ? [_c('p', {
      staticClass: "word is-inline-block"
    }, [_vm._v(_vm._s(question.word))])] : [_c('div', {
      staticClass: "heading is-inline-block"
    }, [_vm._v(_vm._s(_vm.tokens[("lbl_" + (question.type))]))])]], 2), _c('td', [_c('span', {
      staticClass: "is-inline-block"
    }, [_vm._v(_vm._s(question.question))]), _c('i', {
      staticClass: "is-inline-block is-pulled-right answers"
    }, _vm._l((question.answers), function(answer) {
      return _c('span', {
        staticClass: "answer",
        class: {
          'is-correct': answer.isCorrect
        }
      }, [_vm._v(_vm._s(answer.text))])
    }))]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.remove(question)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7519dcc6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/taskEditorQuestionnaire.vue
// module id = 438
// module chunks = 0